export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.102 3.005A1 1 0 0122 4v4a1 1 0 01-1 1h-.5v11.5a1 1 0 01-1 1h-15a1 1 0 01-1-1V9H3a1 1 0 01-1-1V4a1 1 0 011-1h18l.102.005zM5.5 19.5h13V9h-13v10.5zM4 7h16V5H4v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};